'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useState } from 'react';

import { AmbientDot } from './AmbientDot';
import { AvatarMenu } from './AvatarMenu';
import { ComposerIcon, HamburgerIcon } from './icons';
import { MobileDrawer } from './MobileDrawer';
import { NotificationsBell } from './NotificationsBell';
import { Wordmark } from './Wordmark';

type GhBarProps = {
  userInitials?: string;
  hasNotifications?: boolean;
};

export function GhBar({ userInitials = 'AK', hasNotifications = false }: GhBarProps) {
  const pathname = usePathname() ?? '/';
  const [drawerOpen, setDrawerOpen] = useState(false);
  const onComposer = pathname === '/composer' || pathname.startsWith('/composer/');

  return (
    <>
      <header className="gh" role="banner">
        <div className="gh-left">
          <button
            type="button"
            className="gh-hamburger"
            aria-label="Open menu"
            aria-expanded={drawerOpen}
            onClick={() => setDrawerOpen(true)}
          >
            {HamburgerIcon}
          </button>
          <Wordmark />
        </div>
        <div className="gh-center">
          <Link
            href="/composer"
            className={`icon-btn${onComposer ? ' active' : ''}`}
            aria-label="Composer — chat with Hunter"
            aria-current={onComposer ? 'page' : undefined}
          >
            {ComposerIcon}
          </Link>
        </div>
        <div className="gh-right">
          <NotificationsBell hasUnread={hasNotifications} />
          <AmbientDot />
          <AvatarMenu initials={userInitials} />
        </div>
      </header>
      <MobileDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </>
  );
}
